import { useEffect } from "react";
import { faqList } from "@/mocks/gossip";
import SiteHeader from "./components/SiteHeader";
import SiteHero, { HotTicker } from "./components/SiteHero";
import TopicWall from "./components/TopicWall";
import StreamScene from "./components/StreamScene";
import ServiceHub from "./components/ServiceHub";
import WordWall from "./components/WordWall";
import FaqBlock from "./components/FaqBlock";
import AboutContact from "./components/AboutContact";
import SiteFooter from "./components/SiteFooter";
import BackTop from "./components/BackTop";

export default function Home() {
  useEffect(() => {
    const origin = window.location.origin;
    const path = window.location.pathname;
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${origin}${path}`);

    const faqData = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqList.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    };
    const prev = document.getElementById("faq-jsonld");
    if (prev) prev.remove();
    const script = document.createElement("script");
    script.id = "faq-jsonld";
    script.type = "application/ld+json";
    script.text = JSON.stringify(faqData);
    document.head.appendChild(script);
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <SiteHero />
        <HotTicker />
        <TopicWall />
        <StreamScene />
        <ServiceHub />
        <WordWall />
        <FaqBlock />
        <AboutContact />
      </main>
      <SiteFooter />
      <BackTop />
    </div>
  );
}